import { selectIsSearchingTechnique } from "domain/ai-search/ai-search.selectors";
import { forwardRef } from "react";
import { HiCheck } from "react-icons/hi";
import { Sparkle } from "ui/assets/svg/icons/Sparkle";
import { useAppSelector } from "ui/hook/store";
import { translate } from "ui/i18n";
import { useWindowWidth } from "ui/utils/hooks";

interface IProps {
  onClick: () => void;
  className?: string;
}

export const AISearchButton = forwardRef<HTMLButtonElement, IProps>(
  ({ onClick, className }, ref) => {
    const isDesktop = useWindowWidth();
    const isSearching = useAppSelector(selectIsSearchingTechnique);

    return (
      <button
        ref={ref}
        className={`flex items-center space-x-1 rounded-[30px] border border-darkGrey-200 focus-visible:outline-none ${
          isSearching ? "bg-darkGrey-800" : "bg-white"
        } ${isDesktop ? "h-[52px] px-6" : "h-[48px] px-4"} ${className}`}
        onClick={onClick}
      >
        {isSearching ? (
          <HiCheck size={16} className="text-white" />
        ) : (
          <Sparkle />
        )}
        <span
          className={`text-base font-bold ${
            isSearching ? "text-white" : "text-secondaryGrey-900"
          } `}
        >
          {translate("ns1:AI.AI")}
        </span>
      </button>
    );
  }
);
